export default __webpack_public_path__ + "static/media/Carouselimg.4b137b51.png";